import { createContext } from "react";
import type { ISectionProps } from "types/navigation";

export const NavigationItemsContext = createContext<ISectionProps[]>([]);
